import { render, staticRenderFns } from "./UploadEnclosure.vue?vue&type=template&id=e58c902a"
import script from "./UploadEnclosure.vue?vue&type=script&lang=js"
export * from "./UploadEnclosure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports